import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { groupInput, input, InputProvider } from "@redotech/ui/form";
import { memo } from "react";

export const logisticsGeneralForm = groupInput({
  marketplace: input<boolean>(),
  consignmentPercentage: input<number | undefined>(),
});

export type LogisticsGeneralForm = InputProvider.Form<
  typeof logisticsGeneralForm
>;

export type LogisticsGeneralValue = InputProvider.Value<
  typeof logisticsGeneralForm
>;

export const logisticsGeneralDefault: LogisticsGeneralValue = {
  marketplace: false,
  consignmentPercentage: undefined,
};

export const LogisticsGeneralCard = memo(function LogisticsGeneralCard({
  input,
}: {
  input: LogisticsGeneralForm;
}) {
  const { consignmentPercentage } = input.inputs;

  return (
    <RedoIncrementDecrement
      description="Percentage of revenue for consigned marketplace products"
      label="Consignment Percentage"
      max={100}
      min={0}
      setValue={(value) => consignmentPercentage.setValue(value)}
      suffix="%"
      value={consignmentPercentage.value ?? 0}
    />
  );
});
